import { LanguagesEnum } from '@/api/enums';
import { URL_REGEX } from '@/common/constants';
import { TranslationFunctionType } from '@/common/types';
import { boolean, object, string } from 'yup';

const validLanguageCodes = [
  ...new Set(
    Object.values(LanguagesEnum).flatMap((locale) =>
      locale.split('_').map((part) => part.toUpperCase()),
    ),
  ),
];

export const landingPageTemplateSchema = (t: TranslationFunctionType) =>
  object().shape(
    {
      name: string()
        .required(t('error.requiredField'))
        .when(
          'usedForAiGeneratedCampaignTemplate',
          ([usedForAiGeneratedCampaignTemplate], schema) =>
            usedForAiGeneratedCampaignTemplate
              ? schema.test(
                  'language-suffix',
                  t('error.nameLanguageSuffix'),
                  (value: string | undefined) => {
                    if (!value) return false;
                    return validLanguageCodes.some((code) =>
                      value.includes(`- ${code}`),
                    );
                  },
                )
              : schema,
        ),
      usedForAiGeneratedCampaignTemplate: boolean(),
      captureCredentials: boolean(),
      redirectType: string().equals(['template', 'url']),
      redirectUrl: string()
        .nullable()
        .when(
          ['redirectType', 'captureCredentials'],
          ([redirectType, captureCredentials], scheme) =>
            redirectType === 'url' && captureCredentials
              ? string().matches(URL_REGEX || '' || null, t('error.invalidUrl'))
              : scheme,
        ),
      redirectPage: object()
        .nullable()
        .when(
          ['redirectType', 'captureCredentials'],
          ([redirectType, captureCredentials], scheme) =>
            redirectType === 'template' && captureCredentials
              ? object().nullable()
              : scheme,
        ),
    },
    [
      ['name', 'usedForAiGeneratedCampaignTemplate'],
      ['redirectUrl', 'redirectType'],
      ['redirectUrl', 'captureCredentials'],
      ['redirectPage', 'redirectType'],
      ['redirectPage', 'captureCredentials'],
    ],
  );
